import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { executeRefresh, clearRefreshPromise } from "./refreshtokenmanager";
import { ExtractSession } from "../useAuth/SessionExtract";

const data = await ExtractSession("__A-");
const rawBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_RFS_URL,
    credentials: "include",
    headers: {
        // 'Content-Type': 'application/json',
        'X-IWIT': data?.token
    }
});

export const createBaseQueryWithReauth = () => async (args, api, extraOptions) => {
    let result = await rawBaseQuery(args, api, extraOptions);

    if (result.error?.status === 401) {
        try {
            const refreshResponse = await executeRefresh();

            if (refreshResponse.ok) {
                result = await rawBaseQuery(args, api, extraOptions);
            } else {
                clearRefreshPromise();
                window.location.href = "/Login";
            }
        } catch {
            clearRefreshPromise();
            window.location.href = "/Login";
        }
    }

    return result;
};